module.exports = __webpack_public_path__ + "img/select_sign.1ddce134.svg";